import React, { useEffect, useMemo } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Header from './../../compoments/Header';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import api from './../../services/axios'
import AlertDialog from './../../compoments/AlertDialog'
import ImageUpload from './../../compoments/ImageUpload'
import Loading from './../../compoments/Loading'
import Typography from '@material-ui/core/Typography';
import { Breadcrumbs, Divider } from '@material-ui/core';
import { Link } from 'react-router-dom'
import { Redirect } from 'react-router'
import Select from '@material-ui/core/Select'
import FormControl from '@material-ui/core/FormControl'
import InputLabel from '@material-ui/core/InputLabel'
import MenuItem from '@material-ui/core/MenuItem'
import Slider from '@material-ui/core/Slider';
import Input from '@material-ui/core/Input';
import Checkbox from '@material-ui/core/Checkbox';
import ListItemText from '@material-ui/core/ListItemText';


const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
  },
  content: {
    flexGrow: 1,
    height: '100vh',
    overflow: 'auto',
  },
  appBarSpacer: theme.mixins.toolbar,
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
  },
  disabled: {
    padding: 30,
    backgroundColor: 'red'
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 220,
    maxWidth: 700,
  },
}));

export default function FilasUpdate({ match, history }) {


  const rota = 'filas';
  const roleName = 'Filas';
  const [redirect, setRedirect] = React.useState(false);
  const [message, setMessage] = React.useState(false);
  const [alertTitle, setAlertTitle] = React.useState('');
  
  const [id, setId] = React.useState('');
  const [name, setName] = React.useState('');
  const [strategy, setStrategy] = React.useState(null);
  const [timeout, setTimeout] = React.useState('');
  const [retry, setRetry] = React.useState('');
  const [weight, setWeight] = React.useState('');
  
  const [wrapuptime, setWrapuptime] = React.useState('');
  const [reportholdtime, setReportholdtime] = React.useState('');
  const [memberdelay, setMemberdelay] = React.useState('');
  const [announceFrequency, setAnnounceFrequency] = React.useState('');
  const [periodicAnnounceFrequency, setPeriodicAnnounceFrequency] = React.useState('');
  const [announceHoldtime, setAnnounceHoldtime] = React.useState('');
  const [announcePosition, setAnnouncePosition] = React.useState('');
  const [announcePositionLimit, setAnnouncePositionLimit] = React.useState('');
  const [loading, setLoading] = React.useState(true);
  
  const [attendanceCode, setAttendanceCode] = React.useState('');
  const [monitorJoin, setMonitorJoin] = React.useState('');
  const [joinQueue, setJoinQueue] = React.useState('');
  const [joinEmpty, setJoinEmpty] = React.useState('');
  // const [periodicAnnounceFrequency, setPeriodicAnnounceFrequency] = React.useState('');
  const [periodicAnnounce, setPeriodicAnnounce] = React.useState('');
  const [filas, setFilas] = React.useState([]);
  const [audios, setAudios] = React.useState([]);
  const [audiosSelected, setAudiosSelected] = React.useState([]);
  const [attendancePause, setAttendancePause] = React.useState([]);
  const [attendancePauseSelected, setAttendancePauseSelected] = React.useState([]);
  const [joinemptyTransbordo, setJoinemptyTransbordo] = React.useState('');
  

  const joinEmptyData = [
    {value: 'inuse', name: 'Em uso'},
    {value: 'ringing', name: 'Ringing'},
    {value: 'unavailable', name: 'Não disponivel'},
    {value: 'invalid', name: 'Inválido'},
    {value: 'paused', name: 'Pausa'},
  ];

  const frequenciaTempoAnuncioOpt = [
    {name:'5 segundos', value: '5'},
    {name:'10 segundos', value: '10'},
    {name:'15 segundos', value: '15'},
    {name:'20 segundos', value: '20'},
    {name:'25 segundos', value: '25'},
    {name:'30 segundos', value: '30'},
    {name:'35 segundos', value: '35'},
    {name:'40 segundos', value: '40'},
    {name:'45 segundos', value: '45'},
    {name:'50 segundos', value: '50'},
    {name:'55 segundos', value: '55'},
    {name:'60 segundos', value: '60'},
  ];

  const handleChangeEstrategiaFila = (event) => {
    setStrategy(event.target.value);
  };

  const handleChangeFrequenciaTempoAnuncio = (event) => {
    // setFrequenciaTempoAnuncio(event.target.value);
  };

  const estrategiasFilas = [
    {name: 'Interface de anel aleatório', value: 'random'},
    {name: 'Interface de anel que foi desligada recentemente por esta fila', value: 'leastrecent'},
    {name: 'Toca aquele com menos chamadas concluídas desta fila', value: 'fewestcalls'},
    {name: 'Toca todos os canais disponíveis até que um atenda', value: 'ringall'},
  ];

  const loadData = async () => {
    const data = await api.get('/v1/audios/')
    setAudios(data.data.data)
    const dataAtt = await api.get('/v1/attendance-pause/')
    setAttendancePause(dataAtt.data.data)
    const dataF = await api.get('/v1/queue-table/')
    setFilas(dataF.data.data)
    setLoading(false);

  }

  useEffect(() => {
    loadData()
  }, []);

  function valuetext(value) {
    return `${value}°C`;
  }

  const save = async () => {
    const data = new FormData();
    data.append('name', name);
    data.append('joinemptyTransbordo', joinemptyTransbordo);
    data.append('audios', audiosSelected);
    data.append('attendancePause', attendancePauseSelected);
    data.append('strategy', strategy);
    data.append('timeout', timeout);
    data.append('retry', retry);
    data.append('weight', weight);
    data.append('wrapuptime', wrapuptime);
    data.append('reportholdtime', reportholdtime);
    data.append('memberdelay', memberdelay);
    data.append('announceFrequency', announceFrequency);
    data.append('periodicAnnounceFrequency', periodicAnnounceFrequency);
    data.append('announceHoldtime', announceHoldtime);
    data.append('announcePosition', announcePosition);
    data.append('announcePositionLimit', announcePositionLimit);    
    data.append('attendanceCode', attendanceCode);
    data.append('monitorJoin', monitorJoin);
    data.append('joinQueue', joinQueue);
    data.append('joinEmpty', joinEmpty);
    data.append('periodicAnnounce', periodicAnnounce);

    try { 
      const res = await api.post('/v1/queue-table', data, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'multipart/form-data',
        }
      })
      setAlertTitle('')
      history.push('/' + rota)
    } catch(error) {
      setAlertTitle('Erro')
      setMessage(error.response.data.errors[0].message || 'Erro')
    }
  }

  const marks = [
    {
      value: 0,
      label: '0',
    },
    {
      value: 60,
      label: '60 segundos',
    },
    {
      value: 120,
      label: '120 segundos',
    },
    {
      value: 180,
      label: '180 segundos',
    },
    {
      value: 240,
      label: '240 segundos',
    },
  ];

  const marksPeriodicAnnounceFrequency = [
    {
      value: 0,
      label: '0',
    },
    {
      value: 5,
      label: '5',
    },
    {
      value: 10,
      label: '10',
    },
    {
      value: 15,
      label: '15',
    },
    {
      value: 20,
      label: '20',
    },
    {
      value: 25,
      label: '25',
    },
    {
      value: 30,
      label: '30',
    },
    {
      value: 35,
      label: '35',
    },
    {
      value: 40,
      label: '40',
    },
    {
      value: 45,
      label: '45',
    },
    {
      value: 50,
      label: '50',
    },
    {
      value: 55,
      label: '55',
    },
    {
      value: 60,
      label: '60',
    },
  ];

  const classes = useStyles();

  const handleSliderChangeTimeout = (event, newValue) => {
    setTimeout(newValue);
  };

  const handleInputChangeTimeout = (event) => {
    setTimeout(event.target.value === '' ? '' : Number(event.target.value));
  };

  const handleBlurTimeout = () => {
    if (timeout < 0) {
      setTimeout(0);
    } else {
      setTimeout(timeout);
    }
  };

  const handleSliderChangeWrapuptime = (event, newValue) => {
    setWrapuptime(newValue);
  };

  const handleInputChangeWrapuptime = (event) => {
    setWrapuptime(event.target.value === '' ? '' : Number(event.target.value));
  };

  const handleBlurWrapuptime = () => {
    if (wrapuptime < 0) {
      setWrapuptime(0);
    } else {
      setWrapuptime(wrapuptime);
    }
  };


  const handleSliderChangeRetry = (event, newValue) => {
    setRetry(newValue);
  };

  const handleInputChangeRetry = (event) => {
    setRetry(event.target.value === '' ? '' : Number(event.target.value));
  };

  const handleBlurRetry = () => {
    if (retry < 0) {
      setRetry(0);
    } else {
      setRetry(retry);
    }
  };

  const handleSliderChangeReportholdtime = (event, newValue) => {
    setReportholdtime(newValue);
  };

  const handleInputChangeReportholdtime = (event) => {
    setReportholdtime(event.target.value === '' ? '' : Number(event.target.value));
  };

  const handleBlurReportholdtime = () => {
    if (reportholdtime < 0) {
      setReportholdtime(0);
    } else {
      setReportholdtime(reportholdtime);
    }
  };

  const handleSliderChangeMemberdelay = (event, newValue) => {
    setMemberdelay(newValue);
  };

  const handleInputChangeMemberdelay = (event) => {
    setMemberdelay(event.target.value === '' ? '' : Number(event.target.value));
  };

  const handleBlurMemberdelay = () => {
    if (memberdelay < 0) {
      setMemberdelay(0);
    } else {
      setMemberdelay(memberdelay);
    }
  };

  const handleSliderChangeAnnounceFrequency = (event, newValue) => {
    setAnnounceFrequency(newValue);
  };

  const handleInputChangeAnnounceFrequency = (event) => {
    setAnnounceFrequency(event.target.value === '' ? '' : Number(event.target.value));
  };

  const handleBlurAnnounceFrequency = () => {
    if (announceFrequency < 0) {
      setAnnounceFrequency(0);
    } else {
      setAnnounceFrequency(announceFrequency);
    }
  };

  const handleSliderChangePeriodicAnnounceFrequency = (event, newValue) => {
    setPeriodicAnnounceFrequency(newValue);
  };

  const handleInputChangePeriodicAnnounceFrequency = (event) => {
    setPeriodicAnnounceFrequency(event.target.value === '' ? '' : Number(event.target.value));
  };

  const handleBlurPeriodicAnnounceFrequency = () => {
    if (periodicAnnounceFrequency < 0) {
      setPeriodicAnnounceFrequency(0);
    } else {
      setPeriodicAnnounceFrequency(periodicAnnounceFrequency);
    }
  };

  const handleSliderChangePeriodicAnnounce = (event, newValue) => {
    setPeriodicAnnounce(newValue);
  };

  const handleInputChangePeriodicAnnounce = (event) => {
    setPeriodicAnnounce(event.target.value === '' ? '' : Number(event.target.value));
  };

  const handleBlurPeriodicAnnounce = () => {
    if (periodicAnnounce < 0) {
      setPeriodicAnnounce(0);
    } else {
      setPeriodicAnnounce(periodicAnnounce);
    }
  };

  return (
    <div className={classes.root}>
      {redirect && <Redirect to={redirect} />}
      <CssBaseline />
      <Header titleHeader={'Cadastrar Filas'} />
      {/* CONTEUDO */}
      <main className={classes.content}>
        <div className={classes.appBarSpacer} />
        <Container maxWidth="lg" className={classes.container}>
          {loading ?  <Loading /> : 
          <Grid container spacing={3}>
            {/* Recent Orders */}
            <Grid item xs={12}>
              <Breadcrumbs aria-label="breadcrumb">
                <Link color="inherit" to={`/${rota}`} >
                  {roleName}
                </Link>
                <Typography color="textPrimary">Cadastrar</Typography>
              </Breadcrumbs>
            </Grid>
            <Grid item xs={12}>
              <Paper className={classes.paper}>
                <form className={classes.form} noValidate>
                <Grid container spacing={2}>
                    <Grid item xs={4}>
                      <TextField
                        variant="outlined"
                        required
                        fullWidth
                        id="name"
                        label="Nome da fila"
                        name="name"
                        autoComplete="name"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <FormControl className={classes.formControl}>
                        <InputLabel id="demo-mutiple-checkbox-label">Áudios</InputLabel>
                        <Select
                          id="demo-mutiple-checkbox"
                          multiple
                          value={audiosSelected}
                          onChange={(e)=> { 
                            setAudiosSelected(e.target.value)
                          }}
                          input={<Input />}
                          renderValue={()=>{
                            return audios.filter((f)=>audiosSelected.find((fi)=>fi===f.id)).map((fm)=>fm.name).join(', ');
                          }}
                          MenuProps={MenuProps}
                        >
                          {audios.map(f => (
                            <MenuItem key={f.id} value={f.id}>
                              <Checkbox checked={audiosSelected.indexOf(f.id) > -1} />
                              <ListItemText primary={f.name} />
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12}>
                      <FormControl className={classes.formControl}>
                        <InputLabel id="demo-mutiple-checkbox-label">Motivos de pausa</InputLabel>
                        <Select
                          id="demo-mutiple-checkbox"
                          multiple
                          value={attendancePauseSelected}
                          onChange={(e)=> { 
                            setAttendancePauseSelected(e.target.value)
                          }}
                          input={<Input />}
                          renderValue={()=>{
                            return attendancePause.filter((f)=>attendancePauseSelected.find((fi)=>fi===f.id)).map((fm)=>fm.description).join(', ');
                          }}
                          MenuProps={MenuProps}
                        >
                          {attendancePause.map(f => (
                            <MenuItem key={f.id} value={f.id}>
                              <Checkbox checked={attendancePauseSelected.indexOf(f.id) > -1} />
                              <ListItemText primary={f.description} />
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12}>
                      <FormControl className={classes.formControl}>
                        <InputLabel id="demo-simple-select-label">Estratégia</InputLabel>
                        <Select
                          id="demo-simple-select"
                          value={strategy || ''}
                          onChange={handleChangeEstrategiaFila}
                        >{estrategiasFilas.map(name => (
                          <MenuItem value={name.value} key={name.value}>{name.name}</MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={3} style={{marginBottom: 20, marginTop: 20}}>
                      <Typography id="input-slider" gutterBottom>
                      Tempo da fila
                      </Typography>
                    </Grid>
                    <Grid item xs={6} style={{marginBottom: 20, marginTop: 20}}>
                      <Slider
                        value={typeof timeout === 'number' ? timeout : 0}
                        defaultValue={30}
                        // getAriaValueText={valuetext}
                        aria-labelledby="discrete-slider"
                        valueLabelDisplay="auto"
                        step={1}
                        marks={marks}
                        min={0}
                        max={240}
                        onChange={handleSliderChangeTimeout}
                      />
                    </Grid>
                    <Grid item xs={2} style={{marginLeft: 40, marginTop: 20}}>
                      <Input
                        style={{width: 42}}
                        value={timeout}
                        margin="dense"
                        onChange={handleInputChangeTimeout}
                        onBlur={handleBlurTimeout}
                        inputProps={{
                          step: 1,
                          min: 0,
                          max: 240,
                          type: 'number',
                          'aria-labelledby': 'input-slider',
                        }}
                      />
                    </Grid>
                    <Grid item xs={3} style={{marginBottom: 20, marginTop: 20}}>
                      <Typography id="input-slider" gutterBottom>
                      Tempo para rechamada
                      </Typography>
                    </Grid>
                    <Grid item xs={6} style={{marginBottom: 20, marginTop: 20}}>
                      <Slider
                        value={typeof retry === 'number' ? retry : 0}
                        defaultValue={30}
                        // getAriaValueText={valuetext}
                        aria-labelledby="discrete-slider"
                        valueLabelDisplay="auto"
                        step={1}
                        marks={marks}
                        min={0}
                        max={240}
                        onChange={handleSliderChangeRetry}
                      />
                    </Grid>
                    <Grid item xs={2} style={{marginLeft: 40, marginTop: 20}}>
                      <Input
                        style={{width: 42}}
                        value={retry}
                        margin="dense"
                        onChange={handleInputChangeRetry}
                        onBlur={handleBlurRetry}
                        inputProps={{
                          step: 1,
                          min: 0,
                          max: 240,
                          type: 'number',
                          'aria-labelledby': 'input-slider',
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} style={{marginBottom: 20}}>
                      <TextField
                        variant="outlined"
                        required
                        id="weight"
                        label="Peso da fila"
                        name="weight"
                        autoComplete="weight"
                        value={weight}
                        onChange={(e) => setWeight(e.target.value)}
                      />
                    </Grid>
                    <Grid item xs={3} style={{marginBottom: 20, marginTop: 20}}>
                      <Typography id="input-slider" gutterBottom>
                      Tempo de envio de outra chamada
                        após atendimento:
                      </Typography>
                    </Grid>
                    <Grid item xs={6} style={{marginBottom: 20, marginTop: 20}}>
                      <Slider
                        value={typeof wrapuptime === 'number' ? wrapuptime : 0}
                        defaultValue={30}
                        // getAriaValueText={valuetext}
                        aria-labelledby="discrete-slider"
                        valueLabelDisplay="auto"
                        step={1}
                        marks={marks}
                        min={0}
                        max={240}
                        onChange={handleSliderChangeWrapuptime}
                      />
                    </Grid>
                    <Grid item xs={2} style={{marginLeft: 40, marginTop: 20}}>
                      <Input
                        style={{width: 42}}
                        value={wrapuptime}
                        margin="dense"
                        onChange={handleInputChangeWrapuptime}
                        onBlur={handleBlurWrapuptime}
                        inputProps={{
                          step: 1,
                          min: 0,
                          max: 240,
                          type: 'number',
                          'aria-labelledby': 'input-slider',
                        }}
                      />
                    </Grid>


                    <Grid item xs={3} style={{marginBottom: 20, marginTop: 20}}>
                      <Typography id="input-slider" gutterBottom>
                      Anuncio do tempo em espera do chamador:
                      </Typography>
                    </Grid>
                    <Grid item xs={6} style={{marginBottom: 20, marginTop: 20}}>
                      <Slider
                        value={typeof reportholdtime === 'number' ? reportholdtime : 0}
                        defaultValue={30}
                        // getAriaValueText={valuetext}
                        aria-labelledby="discrete-slider"
                        valueLabelDisplay="auto"
                        step={1}
                        marks={marks}
                        min={0}
                        max={240}
                        onChange={handleSliderChangeReportholdtime}
                      />
                    </Grid>
                    <Grid item xs={2} style={{marginLeft: 40, marginTop: 20}}>
                      <Input
                        style={{width: 42}}
                        value={reportholdtime}
                        margin="dense"
                        onChange={handleInputChangeReportholdtime}
                        onBlur={handleBlurReportholdtime}
                        inputProps={{
                          step: 1,
                          min: 0,
                          max: 240,
                          type: 'number',
                          'aria-labelledby': 'input-slider',
                        }}
                      />
                    </Grid>
                    <Grid item xs={3} style={{marginBottom: 20, marginTop: 20}}>
                      <Typography id="input-slider" gutterBottom>
                      Tempo de Atraso entre o agente e o
                        chamador:
                      </Typography>
                    </Grid>
                    <Grid item xs={6} style={{marginBottom: 20, marginTop: 20}}>
                      <Slider
                        value={typeof memberdelay === 'number' ? memberdelay : 0}
                        defaultValue={30}
                        // getAriaValueText={valuetext}
                        aria-labelledby="discrete-slider"
                        valueLabelDisplay="auto"
                        step={1}
                        marks={marks}
                        min={0}
                        max={240}
                        onChange={handleSliderChangeMemberdelay}
                      />
                    </Grid>
                    <Grid item xs={2} style={{marginLeft: 40, marginTop: 20}}>
                      <Input
                        style={{width: 42}}
                        value={memberdelay}
                        margin="dense"
                        onChange={handleInputChangeMemberdelay}
                        onBlur={handleBlurMemberdelay}
                        inputProps={{
                          step: 1,
                          min: 0,
                          max: 240,
                          type: 'number',
                          'aria-labelledby': 'input-slider',
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} 
                      style={{marginBottom: 20, marginTop: 20, color: 'rgba(0, 0, 0, 0.54)', textAlign: 'center'}}>
                      <h3>Anúncios da fila</h3>
                      <Divider />
                    </Grid>
                    <Grid item xs={3} style={{marginBottom: 20, marginTop: 20}}>
                      <Typography id="input-slider" gutterBottom>
                      Tempo de anuncios:
                      </Typography>
                    </Grid>
                    <Grid item xs={6} style={{marginBottom: 20, marginTop: 20}}>
                      <Slider
                        value={typeof announceFrequency === 'number' ? announceFrequency : 0}
                        defaultValue={30}
                        // getAriaValueText={valuetext}
                        aria-labelledby="discrete-slider"
                        valueLabelDisplay="auto"
                        step={1}
                        marks={marks}
                        min={0}
                        max={240}
                        onChange={handleSliderChangeAnnounceFrequency}
                      />
                    </Grid>
                    <Grid item xs={2} style={{marginLeft: 40, marginTop: 20}}>
                      <Input
                        style={{width: 42}}
                        value={announceFrequency}
                        margin="dense"
                        onChange={handleInputChangeAnnounceFrequency}
                        onBlur={handleBlurAnnounceFrequency}
                        inputProps={{
                          step: 1,
                          min: 0,
                          max: 240,
                          type: 'number',
                          'aria-labelledby': 'input-slider',
                        }}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <FormControl className={classes.formControl}>
                        <InputLabel id="demo-simple-select-label">Tempo estimado de espera</InputLabel>
                        <Select
                          id="demo-simple-select"
                          value={announceHoldtime}
                          onChange={(e)=>setAnnounceHoldtime(e.target.value)}
                        >{[
                          {name: 'Sim', value: 'yes'},
                          {name: 'Não', value: 'no'},
                          {name: 'Uma vez', value: 'once'},
                        ].map(name => (
                          <MenuItem value={name.value} key={name.value}>{name.name}</MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12}>
                      <FormControl className={classes.formControl}>
                        <InputLabel id="demo-simple-select-label">Anuncio de posição em fila</InputLabel>
                        <Select
                          id="demo-simple-select"
                          value={announcePosition}
                          onChange={(e)=>setAnnouncePosition(e.target.value)}
                        >{[
                          {name: 'Sim', value: 'yes'},
                          {name: 'Não', value: 'no'},
                          {name: 'Limite', value: 'limit'},
                          {name: 'More', value: 'more'},
                        ].map(name => (
                          <MenuItem value={name.value} key={name.value}>{name.name}</MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        variant="outlined"
                        type="number"
                        required
                        id="announcePositionLimit"
                        label="QTD de chamadores para reproduzir audio"
                        name="announcePositionLimit"
                        autoComplete="announcePositionLimit"
                        value={announcePositionLimit}
                        onChange={(e) => setAnnouncePositionLimit(e.target.value)}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <FormControl className={classes.formControl}>
                        <InputLabel id="demo-simple-select-label">Número do atendimento</InputLabel>
                        <Select
                          id="demo-simple-select"
                          value={attendanceCode}
                          onChange={(e)=> { 
                            setAttendanceCode(e.target.value);
                          }}
                        >{[
                          {name: 'Obrigatório', value: 1},
                          {name: 'Não obrigatório', value: 0}
                        ].map(name => (
                          <MenuItem value={name.value} key={name.value}>{name.name}</MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} 
                      style={{marginBottom: 20, marginTop: 20, color: 'rgba(0, 0, 0, 0.54)', textAlign: 'center'}}>
                      <h3>Opções de transbordo</h3>
                      <Divider />
                    </Grid>
                    <Grid item xs={12}>
                      <FormControl className={classes.formControl}>
                        <InputLabel id="demo-simple-select-label">Habilitar transbordo</InputLabel>
                        <Select
                          id="demo-simple-select"
                          value={joinemptyTransbordo}
                          onChange={(e)=> { 
                            setJoinemptyTransbordo(e.target.value);
                            if(e.target.value==='no'){
                              setJoinQueue('')
                            }
                          }}
                        >{[
                          {name: 'Sim', value: 'yes'},
                          {name: 'Não', value: 'no'}
                        ].map(name => (
                          <MenuItem value={name.value} key={name.value}>{name.name}</MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                    { joinemptyTransbordo==='yes' &&
                    <> 
                    <Grid item xs={12}>
                      <FormControl className={classes.formControl}>
                        <InputLabel id="demo-simple-select-label">Fila transbordo</InputLabel>
                        <Select
                          id="demo-simple-select"
                          value={joinQueue}
                          onChange={(e) => setJoinQueue(e.target.value)}
                        >{filas.map(name => (
                          <MenuItem value={name.id} key={name.id}>{name.name}</MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12}>
                      <FormControl className={classes.formControl}>
                        <InputLabel id="demo-simple-select-label">Expurgo de chamadores</InputLabel>
                        <Select
                          id="demo-simple-select"
                          value={joinEmpty}
                          onChange={(e) => setJoinEmpty(e.target.value)}
                        >{joinEmptyData.map(name => (
                          <MenuItem value={name.value} key={name.value}>{name.name}</MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                    </>
                    }
                    {/* <Grid item xs={12}>
                      <TextField
                        variant="outlined"
                        required
                        id="joinEmpty"
                        label="Expurgo de chamadores"
                        name="joinEmpty"
                        autoComplete="joinEmpty"
                        value={joinEmpty}
                        onChange={(e) => setJoinEmpty(e.target.value)}
                      /> 
                    </Grid>*/}
                    {/* <Grid item xs={3} style={{marginBottom: 20, marginTop: 20}}>
                      <Typography id="input-slider" gutterBottom>
                      Tempo de envio de outra chamada
                        após atAnuncios para serem reproduzidos:
                      </Typography>
                    </Grid>
                    <Grid item xs={6} style={{marginBottom: 20, marginTop: 20}}>
                      <Slider
                        value={typeof periodicAnnounce === 'number' ? periodicAnnounce : 0}
                        defaultValue={30}
                        // getAriaValueText={valuetext}
                        aria-labelledby="discrete-slider"
                        valueLabelDisplay="auto"
                        step={1}
                        marks={marksPeriodicAnnounceFrequency}
                        min={0}
                        max={60}
                        onChange={handleSliderChangePeriodicAnnounce}
                      />
                    </Grid>
                    <Grid item xs={2} style={{marginLeft: 20, marginTop: 20}}>
                      <Input
                        style={{width: 42}}
                        value={periodicAnnounce}
                        margin="dense"
                        onChange={handleInputChangePeriodicAnnounce}
                        onBlur={handleBlurPeriodicAnnounce}
                        inputProps={{
                          step: 1,
                          min: 0,
                          max: 60,
                          type: 'number',
                          'aria-labelledby': 'input-slider',
                        }}
                      /> */}
                      {/* <TextField
                        variant="outlined"
                        required
                        id="periodicAnnounce"
                        name="periodicAnnounce"
                        autoComplete="periodicAnnounce"
                        value={periodicAnnounce}
                        onChange={handleInputChangePeriodicAnnounce}
                        onBlur={handleBlurPeriodicAnnounce}
                        type="number"
                      /> 
                    </Grid>   */}
                    {/* <Grid item xs={12}>
                      <FormControl className={classes.formControl}>
                        <InputLabel id="demo-simple-select-label">Anuncios para serem reproduzidos</InputLabel>
                        <Select
                          id="demo-simple-select"
                          value={periodicAnnounce}
                          onChange={(e) => { setPeriodicAnnounce(e.target.value) }}
                        >{frequenciaTempoAnuncioOpt.map(name => (
                          <MenuItem value={name.value}>{name.name}</MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid> */}
                    <Grid item xs={6}>
                      <Button
                        onClick={() => {
                          history.push('/' + rota)
                          // setRedirect(`/${rota}`)
                        }}
                        type="button"
                        variant="contained"
                        color="default"
                        style={{ marginRight: 30 }}
                      >
                        Cancelar
                      </Button>
                      <Button
                        type="button"
                        variant="contained"
                        color="primary"
                        onClick={save}
                      >
                        Salvar
                      </Button>
                    </Grid>
                  </Grid>
                </form>
              </Paper>
            </Grid>
          </Grid>
          }
          <AlertDialog message={message}
            onClose={() => setMessage(false)}
            title={alertTitle}
            buttonSuccessText={'OK'}
          />
        </Container>
      </main>
    </div>
  );
}